import { LitElement, css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { AtlCardEvents, AtlCardProps, CardTags } from './card.types.ts';
import classNames from 'classnames';
import { getGlobalStyleSheets } from '../../global-styles';
import { ifDefined } from 'lit/directives/if-defined.js';

@customElement(CardTags.Card)
export class AtlCard extends LitElement implements AtlCardProps {

   static styles = [
      ...getGlobalStyleSheets(),
      css`
         :host {
            display: block;
         }
      `,
   ];

   @property({ type: String})
   internalId?: string;

   @property({ type: String })
   internalClassName?: string;

   @property({ type: String })
   cardTitle?: string;

   @property({ type: String })
   cardDescription?: string;

   @property({ type: Boolean })
   fixedSize?: boolean;

   @property({ type: Boolean })
   cursorPointer?: boolean;
   
   @property({ type: Boolean })
   hoverElevation?: boolean;

   renderTitle() {
      if (this.cardTitle && this.cardTitle?.length > 0) {
         return html`
            <div class="card-title">
               <div class="h5">${this.cardTitle}</div>
            </div>
         `;
      }

      return nothing;
   }

   renderDescription() {
      if (this.cardDescription && this.cardDescription?.length > 0) {
         return html` <div class="card-text">${this.cardDescription}</div> `;
      }

      return nothing;
   }

   render() {
      return html`
         <div
            id="${ifDefined(this.internalId)}"
            class=${classNames(
               'card',
               { 'fixed-size': this.fixedSize },
               { clickable: this.cursorPointer },
               { 'hover-elevation': this.hoverElevation },
               this.internalClassName
            )}
            @click=${() => this._handleCardClick()}
            part="card"
         >
            ${this.renderTitle()}
            <div class=${classNames('card-body p-0', this.internalClassName)}>
               ${this.renderDescription()}
               <slot></slot>
            </div>
         </div>
      `;
   }

   protected _handleCardClick() {
      if (this.cursorPointer) {
         const event = new CustomEvent(AtlCardEvents.CardClick, {
            bubbles: true,
            composed: true,
         });
         this.dispatchEvent(event);
      }
   }
}
